import { z } from 'zod';

export const INBOX_IDENTITY_CHANNELS = [
  'instagram',
  'facebook',
  'quo',
  'whatsapp',
  'klaviyo_sms',
  'intercom',
] as const;
export const InboxIdentityChannelSchema = z.enum(INBOX_IDENTITY_CHANNELS);
export type InboxIdentityChannel = z.infer<typeof InboxIdentityChannelSchema>;

export const INBOX_IDENTITY_STATUSES = ['pending', 'confirmed', 'handoff'] as const;
export const InboxIdentityStatusSchema = z.enum(INBOX_IDENTITY_STATUSES);
export type InboxIdentityStatus = z.infer<typeof InboxIdentityStatusSchema>;

export const INBOX_IDENTITY_CONFIRMATIONS = [
  'postcode',
  'order_number',
  'creator_record',
  'manual',
  'phone',
  'klaviyo_profile',
  'intercom_contact',
] as const;
export const InboxIdentityConfirmationSchema = z.enum(INBOX_IDENTITY_CONFIRMATIONS);
export type InboxIdentityConfirmation = z.infer<typeof InboxIdentityConfirmationSchema>;

export const INBOX_IDENTITY_MAX_FAILED_ATTEMPTS = 2;

export const InboxIdentitySchema = z.object({
  id: z.uuid(),
  channel: InboxIdentityChannelSchema,
  externalId: z.string().nullable(),
  handle: z.string().nullable(),
  sbcUserId: z.uuid().nullable(),
  claimedEmail: z.string().nullable(),
  status: InboxIdentityStatusSchema,
  confirmedVia: InboxIdentityConfirmationSchema.nullable(),
  failedAttempts: z.number().int().nonnegative(),
  confirmedAt: z.iso.datetime().nullable(),
  updatedAt: z.iso.datetime(),
});
export type InboxIdentity = z.infer<typeof InboxIdentitySchema>;

export const InboxCustomerSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('linked'), userId: z.uuid() }),
  z.object({
    status: z.literal('pending'),
    needs: z.literal('postcode_or_order_number'),
    failedAttempts: z.number().int().nonnegative(),
  }),
  z.object({ status: z.literal('unidentified') }),
  z.object({ status: z.literal('handoff') }),
]);
export type InboxCustomer = z.infer<typeof InboxCustomerSchema>;

export const UNIDENTIFIED_CUSTOMER: InboxCustomer = { status: 'unidentified' };

export const LinkInboxIdentitySchema = z.object({
  email: z.email().trim().toLowerCase(),
});
export type LinkInboxIdentity = z.infer<typeof LinkInboxIdentitySchema>;
